import { Component, Inject, Optional } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CaptionService } from '../../../../utils/shared-services/caption.service';
import { WidgetDescriptionDialog } from '../../../store-portal/components/dialogs/widget-description-dialog.component';
import { BrowserStorage } from '../../../../utils/shared-services/browser-storage.service';

@Component({
    selector: 'hoWid0032',
    templateUrl: 'src/app/features/head-office-portal/widgets/templates/wid-003-2.html',
    standalone: false
})
export class HoWid0032 {
    public captions: any;
    public isTimedOut: boolean = false;
    public areDatapointsInvalid: boolean = true;
    public invalidDatapoints: any[] = [];
    public datapoints: any[] = [];

    public headers: string[];
    public labels: string[];
    public datasets: any[];

    public hourData: any[];
    public dayData: string[];

    public activeHour: number = -1;
    public activeView: number = 0;
    public activeDataset: number = 0;
    private selectedColumns: number[] = [16, 4, 3];

    private readonly COLUMN_OPTIONS: { label: string; field: string; decimals: number }[] = [
        { label: 'Customer Count', field: 'CUSTOMER_COUNT', decimals: 0 },
        { label: 'Enforced Gratuity', field: 'ENFORCEDGRATUITY', decimals: 2 },
        { label: 'Customer Count', field: 'CUSTOMER_COUNT', decimals: 0 },
        { label: 'Final Total', field: 'FINALTOTAL', decimals: 2 },
        { label: 'Net Total', field: 'NETTOTAL', decimals: 2 },
        { label: 'Tax 1', field: 'TAX1', decimals: 2 },
        { label: 'Tax 2', field: 'TAX2', decimals: 2 },
        { label: 'Tax 3', field: 'TAX3', decimals: 2 },
        { label: 'Tax 4', field: 'TAX4', decimals: 2 },
        { label: 'Tax 5', field: 'TAX5', decimals: 2 },
        { label: 'Taxable 1', field: 'TAXABLE1', decimals: 2 },
        { label: 'Taxable 2', field: 'TAXABLE2', decimals: 2 },
        { label: 'Taxable 3', field: 'TAXABLE3', decimals: 2 },
        { label: 'Taxable 4', field: 'TAXABLE4', decimals: 2 },
        { label: 'Taxable 5', field: 'TAXABLE5', decimals: 2 },
        { label: 'Total Tax', field: 'TOTALTAX', decimals: 2 },
        { label: 'Transact Count', field: 'TRANSACT_COUNT', decimals: 0 },
        { label: 'Weather Index', field: 'WEATHERINDEX', decimals: 0 },
    ];

    constructor(
        @Inject(Object) @Optional() private widget: any,
        @Inject(CaptionService) private captionService,
        @Inject(MatDialog) private dialog: MatDialog,
        @Inject(BrowserStorage) private browserStorage: BrowserStorage
    ) {
        this.captions = this.captionService.captions;
        this.headers = [this.captions.transCountFront, this.captions.netTotalFront, this.captions.finalTotalFront];
        this.labels = [
            '01:00',
            '02:00',
            '03:00',
            '04:00',
            '05:00',
            '06:00',
            '07:00',
            '08:00',
            '09:00',
            '10:00',
            '11:00',
            '12:00',
            '13:00',
            '14:00',
            '15:00',
            '16:00',
            '17:00',
            '18:00',
            '19:00',
            '20:00',
            '21:00',
            '22:00',
            '23:00',
            '24:00',
        ];

        this.hourData = Array(24)
            .fill(null)
            .map(() => this.getEmptyRowValues());
        this.dayData = this.getEmptyRowValues();
        if (this.widget?.id) {
            this.datapoints = this.browserStorage.getSessionstorage(this.widget.id, null);
        }
    }

    openInfoDialog() {
         this.dialog.open(WidgetDescriptionDialog, {
             panelClass: 'app-full-bleed-dialog',
             maxWidth: '95vw',
             data: {
                 widgetID: 'ho-' + this.widget.id,
             },
         });
    }

    cycleViews() {
        this.activeView = (this.activeView + 1) % 2;
    }

    setDataset(val: number) {
        this.activeDataset = val;
        let dataset = [];
        for (let i = 0; i < this.hourData.length; i++) {
            dataset.push(this.hourData[i][val]);
        }
        this.datasets = [{ data: dataset }];
    }

    private parseSelection(value: any, fallback: number): number {
        const parsed = parseInt(value, 10);
        return Number.isNaN(parsed) ? fallback : parsed;
    }

    private getColumnConfig(optionIndex: number): { label: string; field: string; decimals: number } {
        return this.COLUMN_OPTIONS[optionIndex] ?? this.COLUMN_OPTIONS[0];
    }

    private formatMetric(value: number, decimals: number): string {
        return decimals === 0 ? Math.round(value).toString() : value.toFixed(decimals);
    }

    private getMetricValue(record: any, optionIndex: number): number {
        const column = this.getColumnConfig(optionIndex);
        const rawVal = record?.[column.field];
        const parsed = Number(rawVal);
        return Number.isFinite(parsed) ? parsed : 0;
    }

    private initializeColumns(config: any): void {
        this.selectedColumns = [
            this.parseSelection(config?.hourlySalesBreakdown2column2Selection, 16),
            this.parseSelection(config?.hourlySalesBreakdown2column3Selection, 4),
            this.parseSelection(config?.hourlySalesBreakdown2column4Selection, 3),
        ];

        this.headers = this.selectedColumns.map((optionIdx) => this.getColumnConfig(optionIdx).label);
    }

    private getEmptyRowValues(): string[] {
        return this.selectedColumns.map((optionIdx) => this.formatMetric(0, this.getColumnConfig(optionIdx).decimals));
    }

    ngOnInit() {
        //adding the configured value for the activeView and activeDataset
        let portalData = this.browserStorage.getSessionstorage('hoPortalData', null);
        let data = JSON.parse(JSON.stringify(portalData));
        let config;
        if (data.WidgetValueConfig) {
            config = JSON.parse(data.WidgetValueConfig);
        }
        
        this.initializeColumns(config);

        let selectedView = this.parseSelection(config?.hourlySalesBreakdown2column1Selection, 0);
        if (selectedView === 0) {
            this.activeView = 0;
        } else {
            this.activeView = 1;
            this.activeDataset = selectedView - 1;
        }

        // to change animation on wid-000
        if (this.widget && this.widget.isTimedOut) {
            this.isTimedOut = true;
            return;
        }

        if (!this.widget || !this.widget.isLoaded) {
            return;
        }

        // Verify datapoints, making sure they are not null or undefined
        this.areDatapointsInvalid = false;
        for (let i = 0; i < this.widget.data.length; i++) {
            if (!this.widget.data[i]) {
                this.areDatapointsInvalid = true;
                this.invalidDatapoints.push(this.datapoints[i]);
            }
        }
        if (this.areDatapointsInvalid) {
            return;
        }

        let hourDataset = this.widget.data[0].Record;
        if (!hourDataset) {
            this.datasets = [];
            this.hourData = Array(24)
                .fill(null)
                .map(() => this.getEmptyRowValues());
            this.dayData = this.getEmptyRowValues();
            return;
        }

        hourDataset = Array.isArray(hourDataset) ? hourDataset : [hourDataset];
        this.hourData = Array(24)
            .fill(null)
            .map(() => this.getEmptyRowValues());
        hourDataset.forEach((hour) => {
            const hourIndex = Number(hour.TIMEEND_HOUR);
            if (!Number.isFinite(hourIndex) || hourIndex < 0 || hourIndex > 23) {
                return;
            }

            this.hourData[hourIndex] = this.selectedColumns.map((optionIdx) => {
                const val = this.getMetricValue(hour, optionIdx);
                return this.formatMetric(val, this.getColumnConfig(optionIdx).decimals);
            });
        });
        this.setDataset(this.activeDataset);

        const dayTotals = [0, 0, 0];
        hourDataset.forEach((e: any) => {
            this.selectedColumns.forEach((optionIdx, colIdx) => {
                dayTotals[colIdx] += this.getMetricValue(e, optionIdx);
            });
        });
        this.dayData = this.selectedColumns.map((optionIdx, colIdx) =>
            this.formatMetric(dayTotals[colIdx], this.getColumnConfig(optionIdx).decimals)
        );
    }
}
